import { View, Text, StyleSheet, TextInput, Image, Dimensions, PixelRatio, Modal, ScrollView, TouchableOpacity, ActivityIndicator, FlatList } from 'react-native'
import React, { useEffect, useState } from 'react'
import Colours from '../utils/Colours'
import TopHeaderComponent from '../screens/aTopHeader/TopHeaderComponent';
import AppTextInput from '../utils/ColourThemes/AppTextInput';
import { Ionicons } from '@expo/vector-icons';
import Comments from '../icons/Comments';
import useAxiosPrivate from '../hooks/useAxiosPrivate';

const { width, height } = Dimensions.get('window');
const dpr = Math.round(PixelRatio.get() || 1);
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;
const VAL_NAME = 'dxfdmlk0f';
const MAX_RETRIEZ = 20;

// Function to adjust font size
const dynamicFontSize = (size) => {
    const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
    const newSize = size * scaleFactor;

    return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;


const dynamicCelebThumbnailHeight = Math.round((width / BASE_WIDTH) * 35);
const dynamicCelebThumbnailWidth = Math.round((width / BASE_WIDTH) * 35);


const CommentReplysComponent = ({ commentId, selectedCelebratory, tableID, tableCommentsReplies }) => {
    const [isCommentFocused, setIsCommentFocused] = useState(false)
    const [isLoadingComment, setIsLoadingComment] = useState(false)
    const [isCommentSent, setIsCommentSent] = useState(false)
    const [isLoadingReplys, setIsLoadingReplys] = useState(false)
    const [commentText, setCommentText] = useState('')
    const [commentCount, setCommentReplyCount] = useState(0)

    const [tableReplys, setTableReplys] = useState(tableCommentsReplies)

    const [commentReplys, setCommentReplys] = useState([])
    // const [commentReplyCount, setCommentReplyCount] = useState(0)


    const [retryCount, setRetryCount] = useState(0);

    const [imageKey, setImageKey] = useState(0);

    const axiosPrivate = useAxiosPrivate()


    useEffect(() => {
        const fetchReplys = async () => {
            console.log('tableCommentsReplies', tableCommentsReplies)
            if (!selectedCelebratory) return;
            setIsLoadingReplys(true)

            try {
                // Adjust endpoint name if your backend route differs
                const response = await axiosPrivate.get(`/commentReplys/commentReplys/${commentId}`);

                if (response.data?.success) {
                    // Assuming backend sends full comment array
                    setCommentReplys(response.data.replies); // store full comment list
                    setCommentReplyCount(response.data.replies.length); // derive count dynamically
                }
            } catch (err) {
                console.log("Error fetching comments:", err);
            } finally {
                setIsLoadingReplys(false)
            }
        };

        fetchReplys();
    }, []);


    useEffect(() => {
        const fetchReplys = async () => {
            if (!tableID) return;
            setIsLoadingReplys(true)

            try {
                // Adjust endpoint name if your backend route differs
                const response = await axiosPrivate.get(`/commentTableReply/commentTableReply/${commentId}`);

                if (response.data?.success) {
                    // Assuming backend sends full comment array
                    setCommentReplys(response.data.replies); // store full comment list
                    setCommentReplyCount(response.data.count); // derive count dynamically
                }
            } catch (err) {
                console.log("Error fetching comments:", err);
            } finally {
                setIsLoadingReplys(false)
            }
        };

        fetchReplys();
    }, []);

    const handleCommentInput = (text) => {
        setCommentText(text)
    }

    const handleViewComments = () => {

    }


    const getOptimizedCloudinaryUrl = (
        originalUrl,
        targetWidth,
        targetHeight
    ) => {
        if (!originalUrl || !originalUrl.includes(VAL_NAME)) {
            return originalUrl;
        }

        // The 'transformations' string includes the optimization flags
        const transformations = `w_${targetWidth},h_${targetHeight},c_fill,f_auto,q_90,dpr_${dpr}`;

        // Inject the transformations into the URL
        return originalUrl.replace(
            /upload\//,
            `upload/${transformations}/`
        );
    };

    const handleImageError = () => {
        if (retryCount < MAX_RETRIEZ) {
            // Increment the retry counter
            setRetryCount(prevCount => prevCount + 1);

            // Force component re-render by changing the key
            setImageKey(prevKey => prevKey + 1);

            //console.log(`Image failed to load. Retrying... Attempt ${retryCount + 1}`);
        } else {
            // Log final failure or set a state to show a permanent fallback icon
            //console.error('Image failed to load after maximum retries.');
        }
    };
    const handlePostReplys = async () => {
        if (!selectedCelebratory) {
            handleTablePostCommentReplies()
        } else {
            handlePostCelebratoryCommentReplys()
        }
    }
    const handlePostCelebratoryCommentReplys = async () => {


        if (commentText == '') {
            return
        }

        const createdForId = selectedCelebratory?.createdFor?._id;
        const parentComment = commentId; // <-- this is the comment you're replying to

        setIsLoadingComment(true)
        try {
            const response = await axiosPrivate.post('/postComment/postComment', {
                commentText,
                createdForId,
                parentComment,
            });

            // Handle success response
            if (response.status === 200 || response.status === 201) {
                setIsCommentSent(true);
                const newReply = response.data;

                setCommentReplys((prev) => [...prev, newReply]);


                setCommentText('');
                setCommentReplyCount(prev => prev + 1);

                // revert back to normal after a few seconds
                setTimeout(() => setIsCommentSent(false), 2500);

            } else {
                //console.error('Unexpected response:', response);
                // setErrorMessage('Error sending comments')
                // setIsErrorCompVisible(true)
            }
        } catch (error) {

            // setErrorMessage('Error sending comments')
            // setIsErrorCompVisible(true)

        } finally {
            setIsLoadingComment(false);

        }

    }
    const handleTablePostCommentReplies = async () => {
        if (!commentText) return;

        setIsLoadingComment(true)

        console.log('TableComments', tableID)
        console.log('CommentsID', commentId)


        try {
            const response = await axiosPrivate.post('/addComment/addComment', {
                commentText,
                parentComment: commentId,
                tableID: tableID,
            });

            if (response.data.success) {
                setIsCommentSent(true);
                const newReply = response.data.comment;

                setCommentReplys((prev) => [...prev, newReply]);


                setCommentText('');
                setCommentReplyCount(prev => prev + 1);

                // revert back to normal after a few seconds
                setTimeout(() => setIsCommentSent(false), 2500);
            }
        } catch (err) {

            console.error(err);

        } finally {
            setIsLoadingComment(false)
        }
    }





    return (
        <View style={styles.commentContainer}>

            <View style={styles.commentPostContainer}>
                <AppTextInput style={[styles.textDescInputStyle, isCommentFocused && styles.focusedBorder,]}
                    placeholder='Reply ...'
                    numberOfLines={5}
                    multiline
                    value={commentText}
                    onFocus={() => setIsCommentFocused(true)}
                    onBlur={() => setIsCommentFocused(false)}
                    onChangeText={handleCommentInput}
                />
                <View style={styles.commentsPost}>
                    <TouchableOpacity style={styles.comments1}
                        onPress={handleViewComments}
                    >
                        <Comments height={dynamicSize(24)} width={dynamicSize(24)} color={Colours.PRIMARY_LIGHT} />
                        <Text style={styles.comments2}> {commentCount == 0 ? '' : commentCount}</Text>
                    </TouchableOpacity>
                    {isCommentSent ? (
                        <>
                            <Ionicons
                                name={'checkmark-circle'}
                                size={dynamicSize(20)}
                                color={'green'}
                            />
                            <Text
                                style={styles.copyText}
                            >
                                {'Sent!'}
                            </Text>
                        </>
                    ) : (
                        <TouchableOpacity style={styles.commentpPostBtn}
                            onPress={handlePostReplys}
                        >
                            {isLoadingComment ? <ActivityIndicator size="small" color="#fff" />
                                :
                                <Text style={styles.postComment}>Post</Text>}
                        </TouchableOpacity>)}

                </View>
            </View>


            {isLoadingReplys ? (
                <ActivityIndicator size="large" color={Colours.PRIMARY} />
            ) : (<FlatList
                data={commentReplys}
                scrollEnabled={false}
                keyExtractor={(item) => item._id}
                renderItem={({ item }) => {

                    const imageCommentURL = item?.userID.profilePicture

                    const newImageCommentURL = getOptimizedCloudinaryUrl(
                        imageCommentURL,
                        dynamicCelebThumbnailHeight,
                        dynamicCelebThumbnailWidth,
                    );


                    return (
                        <View style={styles.a_comment} >
                            <View>
                                <View style={styles.profileContainer}>
                                    <Image
                                        source={{ uri: newImageCommentURL }}
                                        key={imageKey}
                                        style={[styles.userImage, { backgroundColor: '#d6d4d4ff' }]}
                                        contentFit="cover"
                                        cachePolicy="disk"
                                        onError={handleImageError}
                                    />
                                    <View>
                                        {/* <Text style={{color:Colours.DARKGRAY, fontFamily:'Sen-Regular' }}>Welcome</Text> */}
                                        <Text style={{ fontSize: dynamicFontSize(12), color: Colours.PRIMARY, fontFamily: 'Sen-Regular' }}>{item?.userID.username}</Text>
                                    </View>
                                </View>
                            </View>
                            <Text style={{ fontSize: dynamicFontSize(15), fontFamily: 'Sen-Regular', color: Colours.DARKGRAY, textAlign: 'justify' }}>
                                {item?.commentText}
                            </Text>

                        </View>
                    )
                }} />)}

        </View>
    )
}

const styles = StyleSheet.create({
    commentContainer: {
        display: 'flex',
        // backgroundColor: 'white',
        padding: dynamicSpacing(10),
        borderRadius: dynamicSize(15),
    },
    commentPostContainer: {
        display: 'flex',
        backgroundColor: 'white',
        padding: dynamicSpacing(10),
        borderRadius: dynamicSize(10),
    },
    textDescInputStyle: {
        height: dynamicSize(100),
        marginBottom: dynamicSpacing(10),
        // gap: 10,
        padding: dynamicSpacing(15),
        borderWidth: dynamicSize(3),
        borderColor: Colours.LIGHTGRAY,
        borderRadius: dynamicSize(15),
        fontFamily: 'Sen-Regular',
        fontSize: dynamicFontSize(17),
        verticalAlign: 'top',
        backgroundColor: Colours.LIGHTGRAY,
    },
    focusedBorder: {
        borderColor: Colours.PRIMARY,
    },
    profileContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingTop: dynamicSpacing(15),
        paddingBottom: dynamicSpacing(6),
        gap: dynamicSpacing(10),
    },
    a_comment: {
        display: 'flex',
        backgroundColor: 'white',
        padding: dynamicSpacing(15),
        borderRadius: dynamicSize(10),
        marginTop: dynamicSpacing(15),

    },
    userImage: {
        width: dynamicSize(35),
        height: dynamicSize(35),
        borderRadius: dynamicSize(99),
    },
    hostUserSubContainer: {
        display: 'flex',
        flexDirection: "row",
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: dynamicSpacing(5)
    },
    focusedBorder: {
        borderColor: Colours.PRIMARY,
    },
    commentsPost: {
        display: 'flex',
        flexDirection: 'row',
        gap: dynamicSpacing(22),
        //justifyContent: 'space-between',
        alignItems: 'center',

    },
    comments1: {
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: dynamicSpacing(5),
        //  color: Colours.DARKLIGHTGRAY,
    },
    comments2: {
        fontSize: dynamicFontSize(13),
        color: Colours.PRIMARY_LIGHT,
        fontFamily: 'Sen-Regular',
    },

    commentpPostBtn: {
        backgroundColor: Colours.PRIMARY,
        paddingVertical: dynamicSpacing(6),
        paddingHorizontal: dynamicSpacing(15),
        borderRadius: dynamicSize(5),
    },
    postComment: {
        color: 'white',
        fontSize: dynamicFontSize(14),
        fontFamily: 'Sen-Bold',
    },
    textDescInputStyle: {
        height: dynamicSize(85),
        marginBottom: dynamicSpacing(10),
        // gap: 10,
        padding: dynamicSpacing(15),
        borderWidth: dynamicSize(1),
        borderColor: Colours.LIGHTGRAY,
        borderRadius: dynamicSize(15),
        fontFamily: 'Sen-Regular',
        fontSize: dynamicSize(15),
        verticalAlign: 'top',
        backgroundColor: Colours.LIGHTGRAY,
    },

    copyButton: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: dynamicSpacing(5),
    },
    copyText: {
        color: 'green',
        fontFamily: 'Sen-Regular',
        fontSize: dynamicFontSize(14),
    },

})


export default CommentReplysComponent